import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AggregateReportService } from "src/app/_services/report-services/aggregate-report.service";
import { map, switchMap } from "rxjs/operators";
import { GetStatisticsTableLength, GetStatisticsTableLengthSuccess, ResetStatisticsTables, ResetStatisticsTablesSuccess } from "./aggregate-report.actions";
import { ResetLearnerReportTable } from "../learner-report/learner-report.actions";

@Injectable()
export class AggregateReportEffects {
  constructor(
    private actions$: Actions,
    private aggregateReportService: AggregateReportService
  ) {}

  public getTableListLength$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetStatisticsTableLength),
      switchMap((payload) => 
        this.aggregateReportService.getTableLength$(payload.uri).pipe(
          map((result: number) => {
            return GetStatisticsTableLengthSuccess({result: result});
          })
        )
      )
    )
  );

  public resetStatisticsTables$ = createEffect(() => 
    this.actions$.pipe(
      ofType(ResetStatisticsTables),
      switchMap((payload) => 
        this.aggregateReportService.resetTableLength$(payload.uri).pipe(
          map((result: boolean) => {
            return ResetStatisticsTablesSuccess({result: result, reportType: payload.reportType});
          })
        )
      )
    )
  );
  
  public resetTable$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ResetStatisticsTablesSuccess),
      map((result) => {
        return ResetLearnerReportTable({reportType: result.reportType});
      })
    )
  )
}